import React from 'react';
import { Card, Center, Stack } from '@fiverr-private/layout_components';
import { MinimizeIcon } from '@fiverr-private/visuals';
import { Typography } from '@fiverr-private/typography';
import { IconButton, Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import { Video } from '@fiverr-private/media';
import pathfinder from '@fiverr-private/pathfinder';
import { ElementType } from '@fiverr-private/bianka_js';
import { BiEventData } from '@fiverr-private/store_builder_bi_events';
import { reportClickEvent } from '../../utils/report-bi-event/reportClickEvent';
import { PLATFORM, STEP_SLUG, VIDEO } from './FloatingModalPopup.constants';

export interface FloatingModalPopupProps {
    setIsPopupOpen: (isOpen: boolean) => void;
    biEventData: BiEventData;
    pageName: string;
}

export const FloatingModalPopup = ({
    setIsPopupOpen,
    biEventData,
    pageName,
}: React.PropsWithChildren<FloatingModalPopupProps>) => {
    const storeBuilderUrl = pathfinder('ai_store_builder_wizard', {
        platform: PLATFORM,
        step_slug: STEP_SLUG,
    });

    const onCloseClick = () => {
        setIsPopupOpen(false);
    };

    const onStartClick = () => {
        reportClickEvent({
            biEventData,
            eventType: 'clicked_on_bys_sticky_component',
            elementName: 'bys_floating_sticky_component',
            elementType: ElementType.BUTTON,
            pageName,
        });
        setIsPopupOpen(false);
        window.location.href = storeBuilderUrl;
    };

    return (
        <Card
            background="white"
            dropShadow="z2"
            borderRadius="xl"
            maxWidth={{
                default: '282px',
                md: '345px',
            }}
            maxHeight={{
                default: '446px',
                md: '444px',
            }}
            height="100%"
        >
            <Stack justifyContent="flexEnd" alignItems="center" paddingRight="6">
                <IconButton aria-label="Like" variant="ghost" size="xs" onClick={onCloseClick}>
                    <MinimizeIcon color="grey_900" />
                </IconButton>
            </Stack>
            <Stack direction="column" padding="6" paddingTop="0" gap="6">
                <Center>
                    <Video
                        sources={[VIDEO]}
                        autoPlay
                        loop
                        muted
                        playsInline
                        controls={false}
                        width={{
                            default: '234px',
                            md: '297px',
                        }}
                        height={{
                            default: '126px',
                            md: '160px',
                        }}
                        borderRadius="md"
                    />
                </Center>
                <Stack direction="column" gap="6">
                    <Stack direction="column" gap="2">
                        <Typography color="grey_1200" size="b_xl">
                            <I18n k="store_builder_ui.floating_modal_popup.title" />
                        </Typography>
                        <Typography color="grey_1200" size="b_md">
                            <I18n k="store_builder_ui.floating_modal_popup.description" />
                        </Typography>
                    </Stack>
                    <Button size="sm" onClick={onStartClick}>
                        <I18n k="store_builder_ui.get_started_button" />
                    </Button>
                </Stack>
            </Stack>
        </Card>
    );
};
